import React from "react";
import ExamInfo from "./ExamInfo";
function ExamDetails(props) {
  return <ExamInfo {...props} />;
}
export default ExamDetails;
